import {
  GET_CALL_PROFILE_STICKY_COLUMNS,
  GET_CALL_PROFILE_STICKY_COLUMNS_SUCCESS,
  GET_CALL_PROFILE_STICKY_COLUMNS_ERROR,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS_SUCCESS,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS_ERROR
} from "./actionTypes"

export const getCallProfileStickyColumns = () => {
  return {
    type: GET_CALL_PROFILE_STICKY_COLUMNS,
  }
}

export const getCallProfileStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CALL_PROFILE_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getCallProfileStickyColumnsError = error => {
  return {
    type: GET_CALL_PROFILE_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateCallProfileStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CALL_PROFILE_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateCallProfileStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CALL_PROFILE_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateCallProfileStickyColumnsError = error => {
  return {
    type: UPDATE_CALL_PROFILE_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}